(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compramos-iphone"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var WA_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12.04 2a9.9 9.9 0 0 0-8.5 14.98L2 22l5.17-1.5A9.92 9.92 0 1 0 12.04 2Zm0 18.08a8.15 8.15 0 0 1-4.16-1.14l-.3-.18-3.07.89.92-3-.19-.31a8.17 8.17 0 1 1 6.8 3.74Zm4.48-6.1c-.25-.12-1.46-.72-1.69-.8-.23-.08-.39-.12-.56.12-.16.25-.64.8-.79.97-.14.16-.29.18-.54.06a6.7 6.7 0 0 1-1.98-1.22 7.43 7.43 0 0 1-1.37-1.7c-.14-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.12-.15.16-.25.25-.41.08-.17.04-.31-.02-.44-.06-.12-.56-1.35-.77-1.85-.2-.48-.41-.42-.56-.42h-.48a.92.92 0 0 0-.66.31 2.78 2.78 0 0 0-.87 2.07 4.83 4.83 0 0 0 1.01 2.56 11.06 11.06 0 0 0 4.23 3.74c.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.47-.07 1.46-.6 1.66-1.18.21-.58.21-1.07.15-1.18-.06-.1-.23-.17-.48-.29Z"/></svg>';
    var PHONE_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6.5" y="2.5" width="11" height="19" rx="2.6" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M10.5 5.2h3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
    var CAM_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 8.5h3l1.6-2.5h6.8L17 8.5h3v10H4z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="12" cy="13.2" r="3.4" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';

    // Una pregunta por pantalla. `when` decide si el paso aplica; `type` cómo se responde:
    //   opts  → botones (capacidad, color, sí/no) · rows → filas con descripción (pantalla y carcasa; cambian el iPhone 3D)
    //   pct   → número exacto (batería)           · multi → varias opciones + Continuar (qué falla)
    var ESTADOS_PANTALLA = [
      ['impecable', 'Impecable', 'Ni un arañazo a la vista. El táctil responde en toda la pantalla, sin manchas ni píxeles muertos.'],
      ['bueno', 'Bueno', 'Alguna marca mínima que no se aprecia a 20 cm. Sin grietas; táctil y píxeles perfectos.'],
      ['usado', 'Usado', 'Arañazos que se ven a simple vista, pero sin grietas. Táctil y píxeles perfectos.'],
      ['roto', 'Roto', 'Tiene alguna grieta, o la pantalla falla: manchas, líneas, píxeles muertos o toques fantasma.']
    ];
    var ESTADOS_CARCASA = [
      ['impecable', 'Impecable', 'Sin arañazos ni golpes a la vista en el marco ni en la trasera.'],
      ['bueno', 'Bueno', 'Alguna marca mínima que no se aprecia a 20 cm. Sin golpes.'],
      ['usado', 'Usado', 'Arañazos o roces visibles, sin grietas ni golpes fuertes.'],
      ['roto', 'Roto', 'Cristal trasero roto, golpes marcados, cámara rayada o marco doblado.']
    ];
    var QUESTIONS = [
      { key: 'cap', title: '¿Qué capacidad tiene?', hint: 'Si no lo sabes: Ajustes › General › Información.', type: 'cap', ry: -18, face: 'front' },
      { key: 'screen', title: '¿Cómo está la pantalla?', hint: 'Míralo sin funda ni protector y con buena luz. El iPhone de la izquierda te lo enseña.', type: 'rows', options: ESTADOS_PANTALLA, ry: 0, face: 'front' },
      { key: 'body', title: '¿Cómo están los laterales y la trasera?', type: 'rows', options: ESTADOS_CARCASA, ry: 180, face: 'back' },
      { key: 'battery', title: '¿Qué salud tiene la batería?', hint: 'Lo ves en Ajustes › Batería › Estado y carga. Pon el número exacto, por ejemplo 89.', type: 'pct', ry: -18, face: 'front' },
      { key: 'works', title: '¿Funciona todo?', type: 'opts', checklist: [
        'Se enciende, se apaga y carga con normalidad.',
        'Las cámaras delantera y trasera hacen fotos nítidas.',
        'Altavoces y micrófonos funcionan.',
        'Face ID o Touch ID funciona.',
        'Wi-Fi, Bluetooth, cobertura y todos los botones van bien.'
      ], hint: 'Si alguna de estas cosas falla, marca «No» y dinos qué es: te descontamos lo que cuesta repararlo.', options: [['si', 'Sí, todo'], ['no', 'No, algo falla']], ry: -18, face: 'front' },
      // Las opciones salen de los «Descuentos por avería» del panel (se rehacen al cargar los precios); Face ID,
      // Wi-Fi y «Otra cosa» no tienen precio fijo y mandan a WhatsApp.
      { key: 'fails', title: '¿Qué es lo que falla?', hint: 'Marca todo lo que corresponda.', type: 'multi', when: function (a) { return a.works === 'no'; }, options: [], ry: -18, face: 'front' },
      { key: 'free', title: '¿Es libre de operador?', hint: 'Si lo compraste con un contrato de permanencia, puede estar bloqueado.', type: 'opts', options: [['si', 'Sí'], ['no', 'No'], ['nose', 'No lo sé']], ry: -18, face: 'front' },
      { key: 'sim', title: '¿Tiene ranura para SIM física?', type: 'opts', options: [['si', 'Sí'], ['no', 'No, solo eSIM']], ry: -18, face: 'front' },
      { key: 'icloud', title: '¿Puedes cerrar tu sesión de iCloud?', hint: 'Necesitamos que desactives «Buscar mi iPhone» antes de dárnoslo.', type: 'opts', options: [['si', 'Sí'], ['no', 'No']], ry: -18, face: 'front' }
    ];
    var LABELS = { si: 'Sí', no: 'No', nose: 'No lo sé', impecable: 'Impecable', bueno: 'Bueno', usado: 'Usado', roto: 'Roto' };
    // Descuentos por avería (oct. 2026). Por defecto los del panel; el panel manda en cuanto carga los precios.
    // Pantalla / laterales y trasera: Usado o Roto = relaminado / tapa trasera entera; Bueno = la mitad.
    var DESCUENTOS = [
      { id: 'pantalla', nombre: 'Cambio pantalla', precio: 95 }, { id: 'camaras', nombre: 'Cambio cámaras', precio: 90 },
      { id: 'bateria', nombre: 'Cambio batería', precio: 35 }, { id: 'micro-altavoz', nombre: 'Cambio micro/altavoz', precio: 50 },
      { id: 'botones', nombre: 'Arreglo botones', precio: 45 }, { id: 'carga', nombre: 'Carga', precio: 40 },
      { id: 'tapa-trasera', nombre: 'Tapa trasera', precio: 50 }, { id: 'relaminado', nombre: 'Relaminado', precio: 120 },
      { id: 'chasis', nombre: 'Cambio chasis', precio: 70 }, { id: 'faceid', nombre: 'Face ID / Touch ID', precio: 0, noCompramos: true }
    ];
    var ESTETICOS = { relaminado: 1, 'tapa-trasera': 1 };
    var SIN_PRECIO = [['faceid', 'Face ID / Touch ID'], ['senal', 'Wi-Fi o cobertura'], ['otro', 'Otra cosa']];
    var NOMBRE_FALLO = { pantalla: 'Pantalla o táctil', camaras: 'Cámaras', bateria: 'Batería', 'micro-altavoz': 'Micrófono o altavoz', botones: 'Botones', carga: 'Carga', chasis: 'Chasis (doblado o golpeado)' };
    var FAIL_LABELS = {};
    function montarFallos() {
      var q = QUESTIONS.filter(function (x) { return x.key === 'fails'; })[0];
      q.options = DESCUENTOS.filter(function (d) { return !ESTETICOS[d.id]; })
        .map(function (d) { return [d.id, NOMBRE_FALLO[d.id] || d.nombre.replace(/^(cambio|arreglo)( de)? /i, '').replace(/^./, function (c) { return c.toUpperCase(); })]; })
        .concat(SIN_PRECIO.filter(function (o) { return !descuentoDe(o[0]); }));
      FAIL_LABELS = {};
      q.options.forEach(function (o) { FAIL_LABELS[o[0]] = o[1]; });
    }
    montarFallos();
    function descuentoDe(id) { for (var i = 0; i < DESCUENTOS.length; i++) if (DESCUENTOS[i].id === id) return DESCUENTOS[i]; return null; }
    var SHORT = { color: 'Color', screen: 'Pantalla', body: 'Laterales y trasera', battery: 'Batería', works: 'Funciona todo', fails: 'Qué falla', free: 'Libre', sim: 'SIM física', icloud: 'Puede quitar iCloud' };
    var RESUMEN_KEYS = ['color', 'screen', 'body', 'battery', 'works', 'fails', 'free', 'sim', 'icloud'];

    // Color del iPhone 3D según el nombre del color de la tienda (aprox.; lo que no case queda en gris titanio).
    var COLORES = [
      [/natural/i, '#d8d2c6'], [/desierto|desert/i, '#c9ab87'], [/azul|blue/i, '#5b6b8c'], [/negro|black|grafito|graphite|medianoche|midnight|space/i, '#2c2f36'],
      [/blanco|white|plata|silver|estrella|starlight/i, '#e9e9ec'], [/verde|green|alpine/i, '#6f8a74'], [/morado|purple|púrpura|lavanda|lavender|lila|malva|mauve/i, '#a79cc4'],
      [/rosa|pink/i, '#e8b9c6'], [/rojo|red/i, '#b8323a'], [/amarillo|yellow/i, '#e7d47a'], [/naranja|orange|cosmic/i, '#d98a4b'], [/oro|gold|dorado/i, '#e2cfa6'], [/teal|ultramar|ultramarine|cian|sage/i, '#6a8fa0']
    ];
    function colorHex(nombre) {
      for (var i = 0; i < COLORES.length; i++) if (COLORES[i][0].test(nombre || '')) return COLORES[i][1];
      return '#c9ccd3';
    }

    // ---- iPhone 3D (dibujo propio). Dos caras; los daños son grupos que se encienden según data-state. ----
    function phoneFront() {
      var sc = function (d, w, o) { return '<path d="' + d + '" fill="none" stroke="#fff" stroke-width="' + w + '" stroke-opacity="' + o + '" stroke-linecap="round"/>'; };
      return '<svg viewBox="0 0 300 620" aria-hidden="true">' +
        '<defs>' +
        '<linearGradient id="pf-frame" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#f1f2f5"/><stop offset=".5" stop-color="#9ba1ad"/><stop offset="1" stop-color="#d6dae1"/></linearGradient>' +
        '<linearGradient id="pf-screen" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#2e3444"/><stop offset=".55" stop-color="#171b25"/><stop offset="1" stop-color="#3a4254"/></linearGradient>' +
        '<linearGradient id="pf-sheen" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".2"/><stop offset=".45" stop-color="#fff" stop-opacity="0"/></linearGradient>' +
        '<radialGradient id="pf-lens" cx=".4" cy=".35" r=".7"><stop offset="0" stop-color="#5a6678"/><stop offset=".6" stop-color="#151a24"/><stop offset="1" stop-color="#05070b"/></radialGradient>' +
        '<clipPath id="pf-clip"><rect x="16" y="16" width="268" height="588" rx="44"/></clipPath>' +
        '</defs>' +
        '<rect x="4" y="4" width="292" height="612" rx="56" fill="url(#pf-frame)"/>' +
        '<rect x="10" y="10" width="280" height="600" rx="50" fill="#0b0d12"/>' +
        '<g clip-path="url(#pf-clip)">' +
        '<rect x="16" y="16" width="268" height="588" rx="44" fill="url(#pf-screen)"/>' +
        '<path d="M16 16 L240 16 L16 420 Z" fill="url(#pf-sheen)"/>' +
        '<rect x="100" y="34" width="100" height="30" rx="15" fill="#05070b"/><circle cx="182" cy="49" r="7" fill="url(#pf-lens)"/>' +
        '<text x="150" y="150" text-anchor="middle" font-family="-apple-system, Helvetica, Arial, sans-serif" font-size="46" font-weight="300" fill="#fff" fill-opacity=".9">9:41</text>' +
        '<g fill="#fff" fill-opacity=".08"><rect x="44" y="200" width="212" height="16" rx="8"/><rect x="44" y="232" width="150" height="16" rx="8"/><rect x="44" y="300" width="212" height="90" rx="18"/><rect x="44" y="410" width="212" height="90" rx="18"/></g>' +
        // Bueno: una raya finísima casi invisible · Usado: dos o tres arañazos finos · Roto: grieta discreta.
        '<g data-dmg="bueno">' + sc('M208 196 l10 12', 0.45, 0.22) + '</g>' +
        '<g data-dmg="usado">' + sc('M86 232 l26 30', 0.55, 0.26) + sc('M182 268 l-14 22', 0.5, 0.22) + sc('M120 300 l22 8', 0.5, 0.2) + '</g>' +
        '<g data-dmg="roto">' + sc('M226 16 C230 70 212 120 226 176 S236 262 218 340', 1.1, 0.55) + sc('M226 176 l28 -16 M226 176 l-26 22 M222 250 l-24 10', 0.6, 0.45) +
        '<circle cx="226" cy="176" r="2.5" fill="#fff" fill-opacity=".45"/></g>' +
        '</g></svg>';
    }
    function phoneBack() {
      var sc = function (d, w, o) { return '<path d="' + d + '" fill="none" stroke="#f7f9fc" stroke-width="' + w + '" stroke-opacity="' + o + '" stroke-linecap="round"/>'; };
      var lens = function (cx, cy) { return '<circle cx="' + cx + '" cy="' + cy + '" r="27" fill="url(#pb-lens)" stroke="#e4e7ec" stroke-width="4"/><circle cx="' + cx + '" cy="' + cy + '" r="9" fill="#6b7a99" fill-opacity=".7"/>'; };
      return '<svg viewBox="0 0 300 620" aria-hidden="true">' +
        '<defs>' +
        '<linearGradient id="pb-frame" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#f1f2f5"/><stop offset=".5" stop-color="#9ba1ad"/><stop offset="1" stop-color="#d6dae1"/></linearGradient>' +
        '<linearGradient id="pb-shade" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".35"/><stop offset=".5" stop-color="#fff" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity=".18"/></linearGradient>' +
        '<radialGradient id="pb-lens" cx=".4" cy=".35" r=".7"><stop offset="0" stop-color="#5a6678"/><stop offset=".6" stop-color="#151a24"/><stop offset="1" stop-color="#05070b"/></radialGradient>' +
        '<clipPath id="pb-clip"><rect x="12" y="12" width="276" height="596" rx="48"/></clipPath>' +
        '</defs>' +
        '<rect x="4" y="4" width="292" height="612" rx="56" fill="url(#pb-frame)"/>' +
        '<g clip-path="url(#pb-clip)">' +
        '<rect x="12" y="12" width="276" height="596" rx="48" style="fill: var(--cti-phone-color)"/>' +
        '<rect x="12" y="12" width="276" height="596" rx="48" fill="url(#pb-shade)"/>' +
        '<rect x="30" y="30" width="118" height="118" rx="30" fill="#000" fill-opacity=".12"/><rect x="30" y="30" width="118" height="118" rx="30" fill="none" stroke="#fff" stroke-opacity=".45"/>' +
        lens(62, 62) + lens(116, 62) + lens(62, 116) + '<circle cx="118" cy="114" r="10" fill="#fff7d6" stroke="#e5d9a8"/>' +
        '<circle cx="150" cy="330" r="22" fill="#000" fill-opacity=".08"/>' +
        '<g data-dmg="bueno">' + sc('M206 232 l9 12', 0.45, 0.28) + '</g>' +
        '<g data-dmg="usado">' + sc('M70 214 l22 30', 0.55, 0.32) + sc('M196 290 l-12 20', 0.5, 0.28) + sc('M236 176 l8 14', 0.5, 0.26) + '</g>' +
        '<g data-dmg="roto">' + sc('M284 70 C262 120 272 170 246 220 S232 290 248 340', 1.1, 0.55) + sc('M246 220 l26 -14 M246 220 l-24 20', 0.6, 0.45) + '</g>' +
        '</g></svg>';
    }

    function capLabel(c) { c = Number(c); return c >= 1024 ? (c / 1024) + ' TB' : c + ' GB'; }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
    function euros(n) { return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(n); }
    function thumb(m) { return m.img ? '<img class="cti__thumb" src="' + esc(m.img) + '" alt="" loading="lazy" width="36" height="36">' : '<span class="cti__thumb">' + PHONE_SVG + '</span>'; }
    function imeiOk(v) {
      v = String(v || '').replace(/\D/g, '');
      if (v.length !== 15) return false;
      var sum = 0;
      for (var i = 0; i < 15; i++) { var d = Number(v.charAt(i)); if (i % 2 === 1) { d *= 2; if (d > 9) d -= 9; } sum += d; }
      return sum % 10 === 0;
    }
    function dniOk(v) {
      v = String(v || '').toUpperCase().replace(/[\s-]/g, '');
      var m = v.match(/^([XYZ]?)(\d{7,8})([A-Z])$/);
      if (!m || (m[1] ? m[2].length !== 7 : m[2].length !== 8)) return false;
      var n = Number(({ X: '0', Y: '1', Z: '2' }[m[1]] || '') + m[2]);
      return 'TRWAGMYFPDXBNJZSQVHLCKE'.charAt(n % 23) === m[3];
    }
    function ibanOk(v) {
      v = String(v || '').toUpperCase().replace(/\s/g, '');
      if (!/^[A-Z]{2}\d{2}[A-Z0-9]{10,30}$/.test(v)) return false;
      var s = (v.slice(4) + v.slice(0, 4)).replace(/[A-Z]/g, function (c) { return String(c.charCodeAt(0) - 55); });
      var r = 0;
      for (var i = 0; i < s.length; i++) r = (r * 10 + Number(s.charAt(i))) % 97;
      return r === 1;
    }
    var PHOTOS = [['pantalla', 'Pantalla'], ['trasera', 'Trasera'], ['superior', 'Lateral superior'], ['inferior', 'Lateral inferior'], ['izquierdo', 'Lateral izquierdo'], ['derecho', 'Lateral derecho']];
    // Reduce la foto a 1600 px en JPEG para que la subida sea ligera; si el navegador no la decodifica, va el original.
    function shrink(file) {
      return new Promise(function (resolve) {
        var url = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function () {
          var r = Math.min(1, 1600 / Math.max(img.naturalWidth, img.naturalHeight));
          var c = document.createElement('canvas');
          c.width = Math.round(img.naturalWidth * r);
          c.height = Math.round(img.naturalHeight * r);
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          URL.revokeObjectURL(url);
          c.toBlob(function (b) { resolve(b || file); }, 'image/jpeg', 0.82);
        };
        img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
        img.src = url;
      });
    }

    function init(root) {
      var cfg = JSON.parse(root.querySelector('[data-cti-config]').textContent);
      var flow = root.querySelector('[data-cti-flow]');
      var groupsEl = root.querySelector('[data-cti-groups]');
      var emptyEl = root.querySelector('[data-cti-empty]');
      var search = root.querySelector('[data-cti-search]');
      var quiz = root.querySelector('[data-cti-quiz]');
      var selectedEl = root.querySelector('[data-cti-selected]');
      var qEl = root.querySelector('[data-cti-questions]');
      var offer = root.querySelector('[data-cti-offer]');
      var offerBody = root.querySelector('[data-cti-offer-body]');
      var phone = root.querySelector('[data-cti-phone]');
      var faceFront = phone.querySelector('[data-face="front"]');
      var faceBack = phone.querySelector('[data-face="back"]');
      var caption = root.querySelector('[data-cti-phone-caption]');
      var sell = root.querySelector('[data-cti-sell]');
      var sellForm = root.querySelector('[data-cti-sell-form]');
      var photosEl = root.querySelector('[data-cti-photos]');
      var photoCount = root.querySelector('[data-cti-photo-count]');
      var sellError = root.querySelector('[data-cti-sell-error]');
      var sellBtn = root.querySelector('[data-cti-sell-btn]');
      var sellDone = root.querySelector('[data-cti-sell-done]');
      var sellBack = root.querySelector('[data-cti-sell-back]');
      var sellSummary = root.querySelector('[data-cti-sell-summary]');
      var codeBox = root.querySelector('[data-cti-code]');
      var codeToggle = root.querySelector('[data-cti-code-toggle]');
      var codeForm = root.querySelector('[data-cti-code-form]');
      var codeError = root.querySelector('[data-cti-code-error]');
      var codeOffer = root.querySelector('[data-cti-code-offer]');
      var photoBlock = root.querySelector('[data-cti-photo-block]');

      // ---- Formulario de venta por pasos: fotos → IMEI → datos → entrega → cobro → enviar ----
      var sStep = 0;
      function pasosVenta() {
        return ['fotos', 'imei', 'datos', 'entrega', 'pago', 'enviar'].filter(function (k) {
          if (k === 'fotos') return !state.oferta;
          if (k === 'pago') return !state.trade;
          return true;
        });
      }
      function tituloPaso(k) {
        return {
          fotos: 'Fotos de tu iPhone', imei: 'El IMEI de tu iPhone', datos: 'Tus datos',
          entrega: state.trade ? '¿Cómo quieres hacer la parte de pago?' : '¿Cómo nos lo das?',
          pago: '¿Cómo quieres cobrar?', enviar: 'Último paso'
        }[k];
      }
      function irPaso(i) {
        var lista = pasosVenta();
        sStep = Math.max(0, Math.min(i, lista.length - 1));
        var k = lista[sStep];
        sellForm.querySelectorAll('[data-sstep]').forEach(function (el) { el.hidden = el.dataset.sstep !== k; });
        var ultimo = sStep === lista.length - 1;
        sellForm.querySelector('[data-cti-snext]').hidden = ultimo;
        sellBtn.hidden = !ultimo;
        sellForm.querySelector('[data-cti-sfine]').hidden = !ultimo;
        root.querySelector('[data-cti-stitle]').textContent = tituloPaso(k);
        root.querySelector('[data-cti-sprogress-fill]').style.width = Math.round(((sStep + 1) / lista.length) * 100) + '%';
        root.querySelector('[data-cti-sprogress-text]').textContent = 'Paso ' + (sStep + 1) + ' de ' + lista.length;
        sellBack.hidden = !(sStep > 0 || (state.model && !state.oferta));
        sellBack.lastChild.textContent = sStep > 0 ? 'Volver' : 'Volver a mi oferta';
        sellError.hidden = true;
        syncSellForm();
      }
      function validarPaso(k) {
        var el = sellForm.elements;
        sellError.hidden = true;
        var invalido = function () {
          var bad = Array.prototype.filter.call(sellForm.querySelectorAll('[data-sstep="' + k + '"] input[required]:not([type=radio]):not([type=checkbox])'), function (i) { return !i.closest('[hidden]') && !i.checkValidity(); })[0];
          if (bad) { bad.reportValidity(); bad.focus(); return true; }
          return false;
        };
        if (k === 'fotos') {
          var faltan = PHOTOS.filter(function (p) { return !state.photos[p[0]]; });
          photosEl.querySelectorAll('.cti__photo').forEach(function (x) { x.classList.toggle('is-missing', !state.photos[x.dataset.slot]); });
          if (faltan.length) { sellFail('Faltan fotos: ' + faltan.map(function (p) { return p[1].toLowerCase(); }).join(', ') + '.'); return false; }
        }
        if (k === 'imei') {
          if (invalido()) return false;
          if (!imeiOk(el.imei.value)) { sellFail('Revisa el IMEI: son 15 cifras (Ajustes › General › Información).'); el.imei.focus(); return false; }
          if (!state.photos.imei) { sellFail('Falta la captura de pantalla con el IMEI.'); sellForm.querySelector('.cti__photo--captura').classList.add('is-missing'); return false; }
          if (state.oferta && !state.oferta.bateria && !codeBat()) { sellFail('Pon la salud de la batería (un número del 1 al 100).'); return false; }
        }
        if (k === 'datos') {
          if (invalido()) return false;
          if (!dniOk(el.dni.value)) { sellFail('Revisa el DNI/NIE: la letra no coincide.'); el.dni.focus(); return false; }
        }
        if (k === 'entrega') {
          if (state.trade && !tradeMode()) { sellFail('Elige cómo quieres hacer la parte de pago.'); return false; }
          var dv = state.trade ? (tradeMode() === 'tienda' ? 'tienda' : 'recogida') : el.delivery.value;
          if (!dv) { sellFail('Elige si lo recogemos en tu casa o lo traes a la tienda.'); return false; }
          if (dv === 'recogida') {
            var faltaDir = ['street', 'postalCode', 'city', 'province'].filter(function (x) { return !el[x].value.trim(); });
            if (faltaDir.length || !/^\d{5}$/.test(el.postalCode.value.trim())) { sellFail('Completa la dirección de recogida (calle y número, código postal, población y provincia).'); el[faltaDir[0] || 'postalCode'].focus(); return false; }
          }
        }
        if (k === 'pago') {
          if (!el.payment.value) { sellFail('Elige cómo quieres cobrar.'); return false; }
          if (el.payment.value === 'transferencia' && !ibanOk(el.iban.value)) { sellFail('El número de cuenta (IBAN) no es correcto. Si no lo tienes a mano, elige darla más tarde.'); el.iban.focus(); return false; }
        }
        return true;
      }
      function siguientePaso() {
        if (!validarPaso(pasosVenta()[sStep])) return;
        irPaso(sStep + 1);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var primero = sellForm.querySelector('[data-sstep="' + pasosVenta()[sStep] + '"] input:not([type=hidden]):not([type=file])');
        if (primero && window.innerWidth >= 990) setTimeout(function () { primero.focus({ preventScroll: true }); }, 350);
      }
      var B = cfg.batteryMin || 87;
      var bat = function (t) { return String(t).replace(/\{B\}/g, B); };
      var state = { model: null, a: {}, photos: {}, previews: {}, oferta: null, step: 0, done: false, review: false, preview: null, trade: null };
      var tradeEl = root.querySelector('[data-cti-trade]');
      cfg.tradeBonus = 10;
      var TRADE_EXTRAS = 'funda, protector y envío gratis (30 € de valor)';

      // --- Parte de pago: viene de la ficha de un iPhone de la tienda (?para=<handle>&variante=<id>) ---
      function cargarTrade() {
        var params = new URLSearchParams(location.search);
        var handle = params.get('para');
        if (!handle || !/^[a-z0-9-]+$/.test(handle)) return;
        var varId = params.get('variante');
        fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p || !p.title) return;
            var v = (p.variants || []).filter(function (x) { return String(x.id) === String(varId) && x.available; })[0] || (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
            state.trade = { productHandle: p.handle, productTitle: p.title, variantId: v ? String(v.id) : '', variantTitle: v && v.title !== 'Default Title' ? v.title : '', productPrice: Math.round((v ? v.price : p.price) / 100) };
            renderTrade();
            renderOffer();
            syncSellForm();
          })
          .catch(function () {});
      }
      function renderTrade() {
        var t = state.trade;
        tradeEl.hidden = !t;
        if (!t) return;
        tradeEl.innerHTML = '<span>Parte de pago para <strong>' + esc(t.productTitle) + (t.variantTitle ? ' · ' + esc(t.variantTitle) : '') + '</strong>' + (t.productPrice ? ' (' + euros(t.productPrice) + ')' : '') + '. Te descontamos lo que valga tu iPhone <strong>+ ' + euros(cfg.tradeBonus) + '</strong> y te regalamos ' + TRADE_EXTRAS + '.</span>' +
          '<button type="button" class="cti__change" data-cti-trade-quit>Prefiero que me lo paguéis</button>';
      }
      function quitarTrade() {
        state.trade = null;
        renderTrade();
        renderOffer();
        syncSellForm();
        try { var u = new URL(location.href); u.searchParams.delete('para'); u.searchParams.delete('variante'); history.replaceState(null, '', u); } catch (e) {}
      }

      // Caras del iPhone: render propio subido desde el editor, o el dibujo SVG.
      function pintarCaras() {
        var rf = cfg.renders && cfg.renders.front, rb = cfg.renders && cfg.renders.back;
        faceFront.innerHTML = rf && rf.impecable ? ['impecable', 'bueno', 'usado', 'roto'].map(function (st) { return rf[st] ? '<img src="' + esc(rf[st]) + '" alt="" data-render="' + st + '">' : ''; }).join('') : phoneFront();
        faceBack.innerHTML = rb && rb.impecable ? ['impecable', 'bueno', 'usado', 'roto'].map(function (st) { return rb[st] ? '<img src="' + esc(rb[st]) + '" alt="" data-render="' + st + '">' : ''; }).join('') : phoneBack();
      }
      function estadoCara(face, st) {
        face.dataset.state = st;
        face.querySelectorAll('[data-render]').forEach(function (img) { img.style.display = img.dataset.render === st ? 'block' : 'none'; });
      }
      function actualizarPhone() {
        var a = state.a;
        estadoCara(faceFront, (state.preview && state.preview.face === 'front' ? state.preview.st : a.screen) || 'impecable');
        estadoCara(faceBack, (state.preview && state.preview.face === 'back' ? state.preview.st : a.body) || 'impecable');
        root.style.setProperty('--cti-phone-color', colorHex(a.color));
        var q = state.done ? null : pasos()[state.step];
        phone.style.setProperty('--ry', (state.done ? -18 : q ? q.ry : -18) + 'deg');
        var partes = [];
        if (a.screen) partes.push('Pantalla: ' + LABELS[a.screen]);
        if (a.body) partes.push('Carcasa: ' + LABELS[a.body]);
        caption.textContent = state.model ? (partes.join(' · ') || state.model.name) : '';
      }

      function renderModels(filter) {
        var f = (filter || '').toLowerCase().replace(/\s+/g, ' ').trim();
        var groups = {};
        var order = [];
        cfg.models.forEach(function (m) {
          if (f && m.name.toLowerCase().indexOf(f) === -1 && m.name.toLowerCase().replace('iphone ', '').indexOf(f) === -1) return;
          if (!groups[m.gen]) { groups[m.gen] = []; order.push(m.gen); }
          groups[m.gen].push(m);
        });
        groupsEl.innerHTML = order.map(function (g) {
          return '<div class="cti__group"><p class="cti__group-title">' + esc(g) + '</p><div class="cti__models">' +
            groups[g].map(function (m) {
              return '<button type="button" class="cti__model" data-id="' + esc(m.id) + '">' + thumb(m) + '<span class="cti__model-name">' + esc(m.name) + '</span><span class="cti__model-price">' + esc(precioMax(m)) + '</span></button>';
            }).join('') + '</div></div>';
        }).join('');
        emptyEl.hidden = order.length > 0;
      }

      // Lo máximo que se paga por el modelo (impecable, batería buena, capacidad mayor): orienta al elegir.
      function precioMax(m) {
        if (!m.high) return 'Precio a consultar';
        var caps = m.caps.map(Number);
        var steps = Math.max(0, Math.round(Math.log(Math.max.apply(null, caps) / Math.min.apply(null, caps)) / Math.LN2));
        return 'Hasta ' + euros(m.high + steps * (cfg.capStep || 0));
      }

      function pasos() { return QUESTIONS.filter(function (q) { return !q.when || q.when(state.a); }); }
      function respondido(q) {
        if (q.type === 'pct') return state.a.bateriaPct != null;
        if (q.type === 'multi') return Array.isArray(state.a.fails) && state.a.fails.length > 0;
        return state.a[q.key] != null;
      }
      function autoRespondido(q) {
        return (q.type === 'cap' && state.model.caps.length === 1) || (q.type === 'color' && (state.model.colors || []).length === 1);
      }

      function pick(m) {
        state.model = m;
        state.a = {};
        state.step = 0;
        state.done = false;
        state.review = false;
        state.preview = null;
        if (m.caps.length === 1) state.a.cap = m.caps[0];
        if (m.colors && m.colors.length === 1) state.a.color = m.colors[0];
        selectedEl.innerHTML = thumb(m) + '<p class="cti__selected-name">' + esc(m.name) + '</p><button type="button" class="cti__change" data-cti-change>Cambiar de modelo</button>';
        while (state.step < pasos().length && autoRespondido(pasos()[state.step])) state.step++;
        pintarCaras();
        quiz.hidden = false;
        clearPhotos();
        hideSell();
        flow.classList.add('is-quiz');
        root.classList.add('is-focus');
        renderQuestions();
        renderOffer();
        try { var u = new URL(location.href); u.searchParams.set('modelo', m.slug); history.replaceState(null, '', u); } catch (e) {}
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      function reset() {
        state.model = null;
        state.a = {};
        quiz.hidden = true;
        offer.hidden = true;
        hideSell();
        flow.classList.remove('is-quiz');
        root.classList.remove('is-focus');
        try { var u2 = new URL(location.href); u2.searchParams.delete('modelo'); history.replaceState(null, '', u2); } catch (e) {}
        root.querySelector('[data-cti-pick]').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      function irA(i) {
        var lista = pasos();
        if (i >= lista.length) { state.done = true; state.review = false; }
        else { state.step = Math.max(0, i); state.done = false; }
        state.preview = null;
        var saliente = qEl.firstElementChild;
        var pintar = function () { renderQuestions(); renderOffer(); if (window.innerWidth < 990) quiz.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
        if (saliente && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          saliente.classList.add('is-leaving');
          setTimeout(pintar, 170);
        } else pintar();
      }
      function siguiente() {
        if (state.review) {
          var lista = pasos();
          for (var i = state.step + 1; i < lista.length; i++) if (!respondido(lista[i])) { irA(i); return; }
          state.review = false;
          irA(lista.length);
          return;
        }
        irA(state.step + 1);
      }
      function atras() {
        if (state.done) { irA(pasos().length - 1); return; }
        if (state.step === 0) { reset(); return; }
        var i = state.step - 1;
        while (i > 0 && autoRespondido(pasos()[i])) i--;
        irA(i);
      }
      function volverBtn(texto) {
        return '<button type="button" class="cti__back" data-cti-back><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' + esc(texto) + '</button>';
      }

      function renderQuestions() {
        var m = state.model;
        var lista = pasos();
        var prog = root.querySelector('[data-cti-progress]');
        // El iPhone 3D (y la foto del modelo) solo acompaña a las preguntas de estado; en el resto, solo la pregunta.
        var actual = !state.done && lista[state.step];
        quiz.classList.toggle('is-solo', !(actual && (actual.key === 'screen' || actual.key === 'body')));
        actualizarPhone();
        if (state.done) {
          prog.hidden = true;
          qEl.innerHTML = '<div class="cti__step">' + volverBtn('Volver a la última pregunta') +
            '<fieldset class="cti__q"><legend>Comprueba tus respuestas</legend></fieldset>' +
            '<p class="cti__review-ok">Cuanto más exactas sean, más se ajustará el precio al revisar el iPhone.</p>' +
            '<ul class="cti__review" role="list">' +
            '<li><span>Modelo</span><span>' + esc(m.name) + '</span><button type="button" class="cti__change" data-cti-change>Cambiar</button></li>' +
            '<li><span>Capacidad</span><span>' + esc(capLabel(state.a.cap)) + '</span>' + (m.caps.length > 1 ? '<button type="button" class="cti__change" data-cti-edit="cap">Cambiar</button>' : '<span></span>') + '</li>' +
            RESUMEN_KEYS.map(function (k) {
              var q = QUESTIONS.filter(function (x) { return x.key === k; })[0];
              // La que falta sale marcada, con su botón para responderla.
              if (valor(k) == null) {
                if (!q || lista.indexOf(q) === -1 || respondido(q)) return '';
                return '<li class="is-missing"><span>' + esc(SHORT[k]) + '</span><span>Sin responder</span><button type="button" class="cti__change" data-cti-edit="' + k + '">Responder</button></li>';
              }
              var editable = lista.indexOf(q) !== -1 && !autoRespondido(q);
              return '<li><span>' + esc(SHORT[k]) + '</span><span>' + esc(valor(k)) + '</span>' + (editable ? '<button type="button" class="cti__change" data-cti-edit="' + k + '">Cambiar</button>' : '<span></span>') + '</li>';
            }).join('') + '</ul></div>';
          return;
        }
        var q = lista[state.step];
        prog.hidden = false;
        root.querySelector('[data-cti-progress-fill]').style.width = Math.round((state.step / lista.length) * 100) + '%';
        root.querySelector('[data-cti-progress-text]').textContent = 'Pregunta ' + (state.step + 1) + ' de ' + lista.length;
        var head = '<fieldset class="cti__q"><legend>' + esc(bat(q.title)) + '</legend>';
        if (q.checklist) head += '<ul class="cti__checklist">' + q.checklist.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>';
        if (q.hint) head += '<p class="cti__q-hint">' + esc(q.hint) + '</p>';
        var body;
        if (q.type === 'pct') {
          body = '<label class="cti__pct"><input type="number" inputmode="numeric" min="1" max="100" placeholder="89" data-q-input="battery" value="' + (state.a.bateriaPct || '') + '" autofocus><span>%</span></label>' +
            '<div><button type="button" class="button button-primary rounded-corners-md cti__next" data-cti-next' + (state.a.bateriaPct ? '' : ' disabled') + '>Continuar</button></div>';
        } else if (q.type === 'color' && !(m.colors && m.colors.length)) {
          body = '<input class="cti__text" type="text" maxlength="40" placeholder="Ej. Negro, Azul, Titanio natural…" data-q-input="color" value="' + esc(state.a.color || '') + '" autofocus>' +
            '<div><button type="button" class="button button-primary rounded-corners-md cti__next" data-cti-next' + (state.a.color ? '' : ' disabled') + '>Continuar</button></div>';
        } else if (q.type === 'rows') {
          body = '<div class="cti__rows">' + q.options.map(function (o) {
            return '<button type="button" class="cti__row" data-q="' + q.key + '" data-v="' + esc(o[0]) + '" data-face="' + q.face + '" aria-pressed="' + (state.a[q.key] === o[0]) + '"><i aria-hidden="true"></i><strong>' + esc(o[1]) + '</strong><span>' + esc(o[2]) + '</span></button>';
          }).join('') + '</div>';
        } else if (q.type === 'multi') {
          var sel = state.a.fails || [];
          body = '<div class="cti__opts">' + q.options.map(function (o) {
            return '<button type="button" class="cti__opt" data-multi="' + q.key + '" data-v="' + esc(o[0]) + '" aria-pressed="' + (sel.indexOf(o[0]) !== -1) + '">' + esc(o[1]) + '</button>';
          }).join('') + '</div><div><button type="button" class="button button-primary rounded-corners-md cti__next" data-cti-next' + (sel.length ? '' : ' disabled') + '>Continuar</button></div>';
        } else {
          var opts = q.type === 'color' ? m.colors.map(function (c) { return [c, c]; }) : q.type === 'cap' ? m.caps.map(function (c) { return [c, capLabel(c)]; }) : q.options;
          body = '<div class="cti__opts">' + opts.map(function (o) {
            return '<button type="button" class="cti__opt" data-q="' + q.key + '" data-v="' + esc(o[0]) + '" aria-pressed="' + (String(state.a[q.key]) === String(o[0])) + '">' + esc(bat(o[1])) + '</button>';
          }).join('') + '</div>';
        }
        qEl.innerHTML = '<div class="cti__step">' + volverBtn(state.step === 0 ? 'Cambiar de modelo' : 'Volver') + head + body + '</fieldset></div>';
        var foco = qEl.querySelector('[autofocus]');
        if (foco && state.step > 0 && window.innerWidth >= 990) foco.focus({ preventScroll: true });
      }

      function compute() {
        var a = state.a;
        var keys = ['cap', 'screen', 'body', 'battery', 'works', 'free', 'sim', 'icloud'];
        var missing = keys.filter(function (k) { return a[k] == null; }).length;
        if (!state.done) return { kind: 'pending', missing: missing };
        if (a.icloud === 'no') return { kind: 'blocked' };
        // Libre de operador o no sabe → a medida por WhatsApp. Lo estético y lo que falla se descuenta con los precios
        // de reparación del panel; lo que no tiene precio (Face ID, cobertura, otra cosa) → WhatsApp.
        if (a.free !== 'si') return { kind: 'custom', missing: missing };
        if (missing) return { kind: 'pending', missing: missing };
        var quita = [];
        var estetico = function (estado, id, que) {
          var d = descuentoDe(id);
          if (!d || estado === 'impecable') return true;
          var nombre = d.nombre.toLowerCase().indexOf(que) === -1 ? d.nombre + ' de ' + que : d.nombre;
          if (estado === 'bueno') quita.push({ label: nombre + ' (50 %)', eur: Math.round(d.precio / 2) });
          else quita.push({ label: nombre, eur: d.precio });
          return true;
        };
        estetico(a.screen, 'relaminado', 'pantalla');
        estetico(a.body, 'tapa-trasera', 'trasera');
        if (a.works === 'no') {
          var fallos = a.fails || [];
          for (var fi = 0; fi < fallos.length; fi++) {
            var dd = descuentoDe(fallos[fi]);
            if (dd && dd.noCompramos) return { kind: 'nobuy', what: FAIL_LABELS[dd.id] || dd.nombre };
            if (!dd || ESTETICOS[fallos[fi]]) return { kind: 'custom', missing: 0 };
            quita.push({ label: dd.nombre, eur: dd.precio });
          }
        }
        var m = state.model;
        // Un solo precio por modelo: con la batería por debajo del umbral se resta el cambio de batería (si no lo ha
        // marcado ya como avería).
        var base = m.high;
        if (!base) return { kind: 'ask' };
        if (a.battery !== 'si' && !(a.works === 'no' && (a.fails || []).indexOf('bateria') !== -1)) {
          var db = descuentoDe('bateria');
          if (db) quita.push({ label: db.nombre + ' (batería por debajo del ' + B + ' %)', eur: db.precio });
        }
        var minCap = Math.min.apply(null, m.caps.map(Number));
        var steps = Math.max(0, Math.round(Math.log(Number(a.cap) / minCap) / Math.LN2));
        var p = base + steps * (cfg.capStep || 0);
        if (a.sim === 'no') p *= 1 - (cfg.noSimCut || 0) / 100;
        var nuevo = Math.floor(p / 5) * 5;
        var total = quita.reduce(function (t, x) { return t + x.eur; }, 0);
        p = Math.floor((p - total) / 5) * 5;
        if (total && p < 20) return { kind: 'custom', missing: 0 };
        return p > 0 ? { kind: 'price', price: p, nuevo: nuevo, quita: quita } : { kind: 'ask' };
      }

      function valor(k) {
        var a = state.a;
        if (k === 'battery') return a.bateriaPct != null ? a.bateriaPct + ' %' : null;
        if (k === 'color') return a.color || null;
        if (k === 'fails') return a.works === 'no' && a.fails && a.fails.length ? a.fails.map(function (f) { return FAIL_LABELS[f] || f; }).join(', ') : null;
        return a[k] != null ? LABELS[a[k]] : null;
      }
      function summaryText(res) {
        var a = state.a;
        var parts = ['Hola, quiero vender mi ' + state.model.name + (a.cap ? ' de ' + capLabel(a.cap) : '') + '.'];
        RESUMEN_KEYS.forEach(function (k) { if (valor(k) != null) parts.push(SHORT[k] + ': ' + valor(k) + '.'); });
        if (state.trade) parts.push('Lo quiero dar como parte de pago de un ' + state.trade.productTitle + '.');
        if (res.kind === 'price') parts.push('Precio estimado en la web: ' + euros(res.price) + '.');
        else if (res.kind !== 'blocked') parts.push('Os envío fotos de la pantalla, la trasera y los cuatro laterales.');
        return parts.join(' ');
      }
      function waLink(res) { return 'https://wa.me/' + encodeURIComponent(cfg.wa) + '?text=' + encodeURIComponent(summaryText(res)); }
      function ctas(res, label) {
        return '<a class="button rounded-corners-md cti__cta cti__cta--wa" href="' + waLink(res) + '" target="_blank" rel="noopener" data-cti-wa>' + WA_SVG + '<span>' + esc(label) + '</span></a>';
      }
      function perks() {
        return '<div class="cti__perks">' +
          '<p class="cti__perk-pay"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="6" width="18" height="12.5" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M3 10h18M7 15h4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg><span><strong>Pago en 24-48 h al recibirlo</strong><small>Por PayPal o transferencia</small></span></p>' +
          '<ul role="list"><li>Recogida gratis y asegurada, o en tienda</li><li>Si la revisión no coincide, te lo devolvemos gratis</li></ul></div>';
      }

      // Al cliente solo se le enseña el precio final (Iván, 7 oct. 2026); el desglose va al panel en las respuestas.
      function desglose(res) {
        return '';
        return '<div class="cti__desglose"><div><span>Como nuevo</span><span>' + euros(res.nuevo) + '</span></div>' +
          res.quita.map(function (x) { return '<div><span>' + esc(x.label) + '</span><span>− ' + euros(x.eur) + '</span></div>'; }).join('') + '</div>';
      }
      function renderOffer() {
        if (!state.model) return;
        var a = state.a;
        var res = compute();
        offer.hidden = !state.done;
        // Con la tasación terminada, la oferta va arriba y el resumen de respuestas justo debajo.
        if (state.done) { if (offer.nextElementSibling !== qEl) qEl.parentNode.insertBefore(offer, qEl); }
        else if (qEl.nextElementSibling !== offer) qEl.parentNode.insertBefore(offer, qEl.nextElementSibling);
        var head = '<p class="cti__offer-model">' + esc(state.model.name) + '</p><p class="cti__offer-cap">' + (a.cap ? capLabel(a.cap) : '') + '</p>';
        var html;
        if (res.kind !== 'price') hideSell();
        if (res.kind === 'pending') {
          html = head + '<p class="cti__pending">' + (res.missing === 1 ? 'Te falta 1 respuesta' : 'Te faltan ' + res.missing + ' respuestas') + ' para ver tu precio. Te la marcamos en rojo aquí debajo.</p>';
        } else if (res.kind === 'blocked') {
          html = head + '<div class="cti__blocked">Para comprarlo necesitamos que cierres tu sesión de iCloud y desactives «Buscar mi iPhone». Si tienes dudas, escríbenos y te ayudamos a hacerlo.</div>' + ctas(res, 'Hablar por WhatsApp');
        } else if (res.kind === 'nobuy') {
          html = head + '<div class="cti__blocked">Lo sentimos: no compramos iPhone con fallo de ' + esc(res.what) + '.</div>' +
            '<a class="cti__alt" href="' + waLink(res) + '" target="_blank" rel="noopener">¿Tienes dudas? Escríbenos por <span class="cti__wa-word">WhatsApp</span></a>';
        } else if (res.kind === 'custom') {
          html = head + '<p class="cti__price-label">Oferta a medida</p><p class="cti__pending">Por lo que nos cuentas, preferimos verlo contigo para darte un precio justo. Escríbenos por WhatsApp con fotos de la pantalla, la trasera y los cuatro laterales y te respondemos rápido.</p>' + ctas(res, 'Pedir oferta por WhatsApp');
        } else if (res.kind === 'ask') {
          html = head + '<p class="cti__price-label">Precio a consultar</p><p class="cti__pending">Este modelo te lo tasamos al momento por WhatsApp.</p>' + ctas(res, 'Pedir precio por WhatsApp');
        } else if (state.trade) {
          var t = state.trade;
          var total = res.price + cfg.tradeBonus;
          var queda = t.productPrice ? Math.max(0, t.productPrice - total) : null;
          html = head + '<p class="cti__price-label">Tu iPhone como parte de pago</p><p class="cti__price">' + euros(total) + '</p>' + desglose(res) +
            '<div class="cti__trade-calc"><div><span>Tasación de tu ' + esc(state.model.name) + '</span><span>' + euros(res.price) + '</span></div><div><span>Bono por parte de pago</span><span>+ ' + euros(cfg.tradeBonus) + '</span></div>' +
            (queda != null ? '<div class="is-total"><span>' + esc(t.productTitle) + (t.variantTitle ? ' · ' + esc(t.variantTitle) : '') + '</span><span>' + euros(queda) + ' <s style="opacity:.5;font-weight:400">' + euros(t.productPrice) + '</s></span></div>' : '') + '</div>' +
            '<p class="cti__trade-gift">Y de regalo: ' + TRADE_EXTRAS + '.</p>' +
            '<button type="button" class="button button-primary rounded-corners-md cti__cta cti__cta--big" data-cti-sell-open>Continuar con la parte de pago</button>' +
            '<button type="button" class="cti__alt" data-cti-trade-quit>Prefiero que me lo paguéis</button>';
        } else {
          html = '<p class="cti__congrats">¡Enhorabuena!</p><p class="cti__price-label">Aquí tienes tu oferta para tu ' + esc(state.model.name) + (a.cap ? ' de ' + esc(capLabel(a.cap)) : '') + ':</p><p class="cti__price">' + euros(res.price) + '</p>' + desglose(res) +
            '<button type="button" class="button button-primary rounded-corners-md cti__cta cti__cta--big" data-cti-sell-open>Vender mi iPhone</button>' +
            '<a class="cti__alt" href="' + waLink(res) + '" target="_blank" rel="noopener">Prefiero hablar por <span class="cti__wa-word">WhatsApp</span></a>' + perks();
        }
        offerBody.innerHTML = html;
        state.res = res;
      }

      // El formulario es una pantalla aparte: al abrirlo se esconde la tasación y al volver reaparece la oferta.
      function hideSell() {
        sell.hidden = true;
        flow.classList.remove('is-selling');
        sellBack.hidden = true;
        sellSummary.hidden = true;
      }
      function clearPhotos() {
        Object.keys(state.previews).forEach(function (k) { URL.revokeObjectURL(state.previews[k]); });
        state.photos = {};
        state.previews = {};
        sellForm.hidden = false;
        sellDone.hidden = true;
        sellError.hidden = true;
        renderPhotos();
      }
      function renderCaptura() {
        var slot = sellForm.querySelector('.cti__photo--captura');
        if (!slot) return;
        var done = !!state.photos.imei;
        slot.classList.toggle('is-done', done);
        var img = slot.querySelector('img');
        if (done) {
          if (!img) { img = document.createElement('img'); img.alt = ''; slot.appendChild(img); }
          img.src = state.previews.imei;
        } else if (img) img.remove();
      }
      function renderPhotos() {
        renderCaptura();
        photosEl.innerHTML = PHOTOS.map(function (p) {
          var done = !!state.photos[p[0]];
          return '<label class="cti__photo' + (done ? ' is-done' : '') + '" data-slot="' + p[0] + '">' +
            '<input type="file" accept="image/*" data-cti-photo="' + p[0] + '" aria-label="Foto: ' + esc(p[1]) + '">' +
            (done ? '<img src="' + state.previews[p[0]] + '" alt="">' : CAM_SVG) +
            '<span class="cti__photo-label">' + esc(p[1]) + '</span><small>Añadir foto</small></label>';
        }).join('');
        photoCount.textContent = Object.keys(state.photos).length + ' de ' + PHOTOS.length + ' fotos';
      }

      // --- Código de oferta (precio pactado por WhatsApp; se genera en el panel) ---
      codeToggle.addEventListener('click', function () {
        var abierto = codeForm.hidden;
        codeForm.hidden = !abierto;
        codeToggle.setAttribute('aria-expanded', String(abierto));
        if (abierto) codeForm.elements.codigo.focus();
      });
      function aplicarCodigo(raw, desdeUrl) {
        var code = String(raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '').replace(/^SW/, '');
        codeError.hidden = true;
        if (code.length !== 6) { codeError.textContent = 'El código tiene 6 letras o números después de «SW-».'; codeError.hidden = false; return; }
        var btn = codeForm.querySelector('button');
        btn.disabled = true;
        fetch(cfg.endpoint.replace(/\/recompra\/?$/, '/recompra/codigo') + '?c=SW-' + code, { credentials: 'same-origin' })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.error || 'Código no válido'); return d; }); })
          .then(function (d) {
            state.oferta = d;
            flow.hidden = true;
            codeBox.hidden = true;
            photoBlock.hidden = true;
            var mod = cfg.models.filter(function (x) { return x.name.toLowerCase() === String(d.model).toLowerCase(); })[0];
            var cols = (mod && mod.colors) || [];
            var sel = sellForm.elements.codeColor;
            var txt = sellForm.elements.codeColorText;
            sel.innerHTML = '<option value="">Elige el color…</option>' + cols.map(function (c) { return '<option>' + esc(c) + '</option>'; }).join('');
            sel.hidden = !cols.length;
            txt.hidden = !!cols.length;
            root.querySelector('[data-cti-code-bat]').hidden = !!d.bateria;
            root.querySelector('[data-cti-code-extra]').hidden = false;
            var hasta = new Date(d.expiresAt).toLocaleDateString('es-ES', { day: 'numeric', month: 'long' });
            codeOffer.innerHTML = '<div><p class="cti__eyebrow">Tu oferta</p><p class="cti__offer-model" style="font-size:1.2rem">' + esc(d.model) + ' · ' + esc(d.capacity) + '</p>' +
              '<div class="cti__codeoffer-tags"><span>Grado ' + esc(d.grado) + '</span>' + (d.bateria ? '<span>Batería ' + esc(d.bateria) + ' %</span>' : '') + '<span>Código ' + esc(d.code) + '</span></div>' +
              '<p class="cti__price-note" style="margin-top:10px">Precio acordado por WhatsApp, válido hasta el ' + esc(hasta) + '. Lo confirmamos al revisar el iPhone.</p></div>' +
              '<div><p class="cti__price-label">Te pagamos</p><p class="cti__price">' + euros(d.price) + '</p></div>' +
              '<button type="button" class="cti__alt" data-cti-code-reset>No es mi código</button>';
            codeOffer.hidden = false;
            sell.hidden = false;
            sellForm.hidden = false;
            sellDone.hidden = true;
            irPaso(0);
            try { var u = new URL(location.href); u.searchParams.set('codigo', d.code); u.searchParams.delete('modelo'); history.replaceState(null, '', u); } catch (e) {}
            codeOffer.scrollIntoView({ behavior: desdeUrl ? 'auto' : 'smooth', block: 'start' });
          })
          .catch(function (err) { codeError.textContent = err.message; codeError.hidden = false; })
          .then(function () { btn.disabled = false; });
      }
      function codeColor() { var el = sellForm.elements; return (el.codeColor.hidden ? el.codeColorText.value : el.codeColor.value).trim(); }
      function codeBat() { var n = parseInt(sellForm.elements.codeBat.value, 10); return n >= 1 && n <= 100 ? n : null; }
      function quitarCodigo() {
        state.oferta = null;
        root.querySelector('[data-cti-code-extra]').hidden = true;
        codeOffer.hidden = true;
        codeOffer.innerHTML = '';
        codeBox.hidden = false;
        photoBlock.hidden = false;
        flow.hidden = false;
        sell.hidden = true;
        try { var u = new URL(location.href); u.searchParams.delete('codigo'); history.replaceState(null, '', u); } catch (e) {}
        codeBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      codeForm.addEventListener('submit', function (e) { e.preventDefault(); aplicarCodigo(codeForm.elements.codigo.value, false); });

      function openSell() {
        syncSellForm();
        var r = state.res;
        if (state.model && r && r.kind === 'price') {
          var importe = state.trade ? r.price + cfg.tradeBonus : r.price;
          sellSummary.innerHTML = '<span>' + esc(state.model.name) + (state.a.cap ? ' · ' + esc(capLabel(state.a.cap)) : '') + '</span><strong>' + euros(importe) + '</strong>';
          sellSummary.hidden = false;
          sellBack.hidden = false;
          flow.classList.add('is-selling');
        }
        sell.hidden = false;
        sellForm.hidden = false;
        sellDone.hidden = true;
        irPaso(0);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      function sellFail(msg) { sellError.innerHTML = esc(msg); sellError.hidden = false; }

      function submitSell(e) {
        e.preventDefault();
        if (sStep < pasosVenta().length - 1) { siguientePaso(); return; }
        sellError.hidden = true;
        var res = state.res;
        var of = state.oferta;
        if (!of && (!state.model || !res || res.kind !== 'price')) return;
        var missing = of ? [] : PHOTOS.filter(function (p) { return !state.photos[p[0]]; });
        photosEl.querySelectorAll('.cti__photo').forEach(function (el) { el.classList.toggle('is-missing', !state.photos[el.dataset.slot]); });
        if (missing.length) { sellFail('Faltan fotos: ' + missing.map(function (p) { return p[1].toLowerCase(); }).join(', ') + '.'); return; }
        if (of && !of.bateria && !codeBat()) { sellFail('Pon la salud de la batería (un número del 1 al 100).'); return; }
        var el = sellForm.elements;
        // Repaso final de todos los pasos (por si se saltó alguno): vuelve al primero que falle.
        var lista = pasosVenta();
        for (var pi = 0; pi < lista.length - 1; pi++) {
          if (!validarPaso(lista[pi])) { var msg = sellError.innerHTML; irPaso(pi); if (msg) sellFail(msg.replace(/&amp;/g, '&')); return; }
        }
        if (!dniOk(el.dni.value)) { sellFail('Revisa el DNI/NIE: la letra no coincide.'); el.dni.focus(); return; }
        if (!imeiOk(el.imei.value)) { sellFail('Revisa el IMEI: son 15 cifras (Ajustes › General › Información).'); el.imei.focus(); return; }
        if (!state.photos.imei) { sellFail('Falta la captura de pantalla con el IMEI.'); sellForm.querySelector('.cti__photo--captura').classList.add('is-missing'); return; }
        var trade = state.trade;
        var modo = tradeMode();
        if (trade && !modo) { sellFail('Elige cómo quieres hacer la parte de pago.'); return; }
        var deliveryVal = trade ? (modo === 'tienda' ? 'tienda' : 'recogida') : el.delivery.value;
        if (!deliveryVal) { sellFail('Elige si lo recogemos en tu casa o lo traes a la tienda.'); return; }
        if (deliveryVal === 'recogida') {
          var faltaDir = ['street', 'postalCode', 'city', 'province'].filter(function (k) { return !el[k].value.trim(); });
          if (faltaDir.length || !/^\d{5}$/.test(el.postalCode.value.trim())) { sellFail('Completa la dirección de recogida (calle y número, código postal, población y provincia).'); el[faltaDir[0] || 'postalCode'].focus(); return; }
        }
        if (!trade && !el.payment.value) { sellFail('Elige cómo quieres cobrar.'); return; }
        if (!trade && el.payment.value === 'transferencia' && !ibanOk(el.iban.value)) { sellFail('El número de cuenta (IBAN) no es correcto. Si no lo tienes a mano, elige darla más tarde.'); el.iban.focus(); return; }
        if (!el.acceptContract.checked) { sellFail('Tienes que aceptar las condiciones del contrato.'); return; }
        if (el.website.value) return;

        var a = state.a;
        var payload = {
          codigo: of ? of.code : undefined,
          model: of ? of.model : state.model.name,
          capacity: of ? of.capacity : capLabel(a.cap),
          price: of ? of.price : res.price,
          answers: of ? {} : (function () {
            var o = RESUMEN_KEYS.reduce(function (acc, k) { if (valor(k) != null) acc[SHORT[k]] = valor(k); return acc; }, {});
            if (res && res.quita && res.quita.length) o['Descuentos'] = res.quita.map(function (x) { return x.label + ' −' + x.eur + ' €'; }).join(' · ').slice(0, 118);
            return o;
          })(),
          color: of ? codeColor() : a.color,
          bateria: of ? (of.bateria || codeBat()) : a.bateriaPct,
          name: el.name.value.trim(),
          dni: el.dni.value.trim(),
          imei: el.imei.value.replace(/\D/g, ''),
          phone: el.phone.value.trim(),
          email: el.email.value.trim(),
          delivery: deliveryVal,
          tradeIn: trade ? { productHandle: trade.productHandle, productTitle: trade.productTitle, variantId: trade.variantId, variantTitle: trade.variantTitle, productPrice: trade.productPrice, modo: modo } : undefined,
          address: deliveryVal === 'recogida' ? { street: el.street.value.trim(), floor: el.floor.value.trim(), postalCode: el.postalCode.value.trim(), city: el.city.value.trim(), province: el.province.value.trim() } : null,
          payment: trade ? '' : el.payment.value,
          iban: !trade && el.payment.value === 'transferencia' ? el.iban.value.trim() : '',
          accountHolder: !trade && el.payment.value === 'transferencia' ? el.accountHolder.value.trim() : '',
          acceptContract: true,
          source: 'web-compramos-tu-iphone',
          consent: true,
          photos: {}
        };
        // Primero se sube cada foto al almacén del panel (devuelve /api/media/<id>) y luego la tasación con esas URLs.
        var mediaUrl = cfg.endpoint.replace(/\/recompra\/?$/, '/media');
        var upload = function (p) {
          var blob = state.photos[p[0]];
          return fetch(mediaUrl, { method: 'POST', headers: { 'Content-Type': blob.type || 'image/jpeg' }, body: blob, credentials: 'same-origin' })
            .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
            .then(function (d) { payload.photos[p[0]] = d.url; });
        };
        sellBtn.disabled = true;
        sellBtn.textContent = 'Enviando…';
        var waFin = of ? 'https://wa.me/' + encodeURIComponent(cfg.wa) + '?text=' + encodeURIComponent('Hola, acabo de enviar la venta de mi ' + of.model + ' con el código ' + of.code + '.') : null;
        var subidas = (of ? [] : PHOTOS.map(upload)).concat([upload(['imei', 'Captura del IMEI'])]);
        Promise.all(subidas)
          .then(function () {
            return fetch(cfg.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), credentials: 'same-origin' });
          })
          .then(function (r) {
            if (!r.ok) return r.json().catch(function () { return {}; }).then(function (d) { var er = new Error(d.error || 'HTTP ' + r.status); er.servidor = !!d.error; throw er; });
            return r.json().catch(function () { return {}; });
          })
          .then(function (d) {
            sellForm.hidden = true;
            var tienda = payload.delivery === 'tienda';
            var citaUrl = cfg.citasUrl ? cfg.citasUrl + (cfg.citasUrl.indexOf('?') === -1 ? '?' : '&') + 'tipo=venta&modelo=' + encodeURIComponent(payload.model + ' ' + payload.capacity) : '';
            var ti = payload.tradeIn;
            var texto = esc(cfg.thanksText);
            var accion = '';
            if (ti && ti.modo === 'tienda') {
              texto = 'Reserva tu cita: en la tienda revisamos tu iPhone, te descontamos su valor del ' + esc(ti.productTitle) + ' y te llevas funda y protector de regalo.';
            } else if (ti && ti.modo === 'compra_ahora') {
              texto = 'Ya puedes comprar tu ' + esc(ti.productTitle) + '. Recogemos tu iPhone gratis y, en cuanto lo revisemos, te devolvemos su valor al mismo método de pago. Funda y protector van de regalo.';
              if (ti.variantId) accion = '<a class="button button-primary rounded-corners-md cti__cta" href="/cart/add?id=' + esc(ti.variantId) + '&quantity=1&properties[Parte%20de%20pago]=' + encodeURIComponent(d && d.id ? d.id : 'si') + '&return_to=/cart">Comprar el ' + esc(ti.productTitle) + ' ahora</a>';
            } else if (ti && ti.modo === 'envio_primero') {
              texto = 'Te escribimos para organizar la recogida gratuita. En cuanto revisemos tu iPhone te mandamos el código de descuento para comprar el ' + esc(ti.productTitle) + ', con funda, protector y envío de regalo.';
            } else if (tienda) {
              texto = 'Reserva ahora tu cita para traerlo a la tienda: lo revisamos contigo y cerramos la venta allí mismo.';
            }
            if (tienda && citaUrl) accion = '<a class="button button-primary rounded-corners-md cti__cta" href="' + esc(citaUrl) + '" target="_blank" rel="noopener">Pedir cita en la tienda</a>';
            sellDone.innerHTML = '<div class="cti__done" role="status"><p>' + esc(cfg.thanksTitle) + '</p><p>' + texto + '</p></div>' + accion +
              '<a class="cti__alt" href="' + (waFin || waLink(res)) + '" target="_blank" rel="noopener">¿Prefieres seguir por WhatsApp? Escríbenos</a>';
            if (of) codeOffer.hidden = true;
            sellDone.hidden = false;
            sellBack.hidden = true;
            sell.scrollIntoView({ behavior: 'smooth', block: 'start' });
          })
          .catch(function (err) {
            var wa = waFin || waLink(res);
            sellError.innerHTML = (err && err.servidor ? esc(err.message) + ' ' : 'No hemos podido enviarlo ahora mismo. Inténtalo de nuevo o ') + '<a href="' + wa + '" target="_blank" rel="noopener">escríbenos por WhatsApp</a>.';
            sellError.hidden = false;
          })
          .then(function () { sellBtn.disabled = false; sellBtn.textContent = 'Enviar y vender mi iPhone'; });
      }

      root.addEventListener('change', function (e) {
        var input = e.target.closest('[data-cti-photo]');
        if (!input || !input.files || !input.files[0]) return;
        var key = input.dataset.ctiPhoto;
        var file = input.files[0];
        if (file.type && file.type.indexOf('image/') !== 0) { sellFail('Ese archivo no es una foto.'); return; }
        var slot = input.closest('.cti__photo');
        slot.classList.add('is-busy');
        shrink(file).then(function (blob) {
          if (blob.size > 12 * 1024 * 1024) { slot.classList.remove('is-busy'); sellFail('Esa foto pesa demasiado. Prueba con otra.'); return; }
          if (state.previews[key]) URL.revokeObjectURL(state.previews[key]);
          state.photos[key] = blob;
          state.previews[key] = URL.createObjectURL(blob);
          sellError.hidden = true;
          renderPhotos();
        });
      });
      // Dirección solo si lo recogemos; efectivo solo si viene a la tienda; IBAN solo con transferencia ahora.
      function tradeMode() { return state.trade ? (sellForm.elements.tradeMode.value || '') : ''; }
      function syncSellForm() {
        var el = sellForm.elements;
        var trade = !!state.trade;
        root.querySelector('[data-cti-trade-mode]').hidden = !trade;
        root.querySelector('[data-cti-delivery]').hidden = trade;
        var delivery = trade ? (tradeMode() === 'tienda' ? 'tienda' : tradeMode() ? 'recogida' : '') : el.delivery.value;
        root.querySelector('[data-cti-address]').hidden = delivery !== 'recogida';
        root.querySelector('[data-cti-payment]').hidden = trade || !delivery;
        var cash = root.querySelector('[data-cti-cash]');
        cash.hidden = delivery !== 'tienda';
        if (cash.hidden && el.payment.value === 'efectivo') cash.querySelector('input').checked = false;
        root.querySelector('[data-cti-iban]').hidden = trade || el.payment.value !== 'transferencia';
      }
      sellForm.addEventListener('change', syncSellForm);
      sellForm.addEventListener('submit', submitSell);

      root.addEventListener('click', function (e) {
        var mBtn = e.target.closest('.cti__model');
        if (mBtn) {
          var m = cfg.models.filter(function (x) { return x.id === mBtn.dataset.id; })[0];
          if (m) pick(m);
          return;
        }
        if (e.target.closest('[data-cti-change]')) { reset(); return; }
        if (e.target.closest('[data-cti-back]')) { atras(); return; }
        if (e.target.closest('[data-cti-next]')) { siguiente(); return; }
        var ed = e.target.closest('[data-cti-edit]');
        if (ed) {
          var qi = pasos().map(function (q) { return q.key; }).indexOf(ed.dataset.ctiEdit);
          if (qi !== -1) { state.review = true; irA(qi); }
          return;
        }
        var mu = e.target.closest('[data-multi]');
        if (mu) {
          var arr = state.a.fails || [];
          var ix = arr.indexOf(mu.dataset.v);
          if (ix === -1) arr.push(mu.dataset.v); else arr.splice(ix, 1);
          state.a.fails = arr;
          mu.setAttribute('aria-pressed', String(ix === -1));
          var nb = qEl.querySelector('[data-cti-next]');
          if (nb) nb.disabled = !arr.length;
          return;
        }
        var o = e.target.closest('.cti__opt[data-q], .cti__row[data-q]');
        if (o) {
          var antes = state.a[o.dataset.q];
          state.a[o.dataset.q] = o.dataset.v;
          if (antes !== o.dataset.v && o.dataset.q === 'works') delete state.a.fails;
          o.parentElement.querySelectorAll('[data-q]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === o)); });
          state.preview = null;
          actualizarPhone();
          // En pantalla/carcasa se deja ver el cambio en el iPhone antes de pasar; en el resto, enseguida.
          setTimeout(siguiente, o.classList.contains('cti__row') ? 650 : 180);
          return;
        }
        if (e.target.closest('[data-cti-sell-open]')) openSell();
        if (e.target.closest('[data-cti-snext]')) siguientePaso();
        if (e.target.closest('[data-cti-sell-back]')) {
          if (sStep > 0) irPaso(sStep - 1); else hideSell();
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (e.target.closest('[data-cti-code-reset]')) quitarCodigo();
        if (e.target.closest('[data-cti-trade-quit]')) quitarTrade();
      });

      // Al pasar el ratón por un estado, el iPhone lo muestra; al salir, vuelve al elegido.
      qEl.addEventListener('pointerover', function (e) {
        var row = e.target.closest('.cti__row[data-q]');
        if (!row || e.pointerType === 'touch') return;
        state.preview = { face: row.dataset.face, st: row.dataset.v };
        actualizarPhone();
      });
      qEl.addEventListener('pointerout', function (e) {
        var row = e.target.closest('.cti__row[data-q]');
        if (!row || (e.relatedTarget && row.contains(e.relatedTarget))) return;
        state.preview = null;
        actualizarPhone();
      });

      search.addEventListener('input', function () { renderModels(search.value); });
      qEl.addEventListener('input', function (e) {
        var inp = e.target.closest('[data-q-input]');
        if (!inp) return;
        if (inp.dataset.qInput === 'battery') {
          var n = parseInt(inp.value, 10);
          if (n >= 1 && n <= 100) { state.a.bateriaPct = n; state.a.battery = n >= B ? 'si' : 'no'; }
          else { delete state.a.bateriaPct; delete state.a.battery; }
        } else {
          var v = inp.value.replace(/\s+/g, ' ').trim();
          if (v) state.a.color = v; else delete state.a.color;
          actualizarPhone();
        }
        var nb = qEl.querySelector('[data-cti-next]');
        if (nb) nb.disabled = !respondido(pasos()[state.step]);
      });
      qEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.closest('[data-q-input]')) {
          e.preventDefault();
          if (respondido(pasos()[state.step])) siguiente();
        }
      });

      renderModels('');
      renderPhotos();
      cargarTrade();

      // Los precios se editan en el panel (Precios de recompra): se leen al cargar y mandan sobre los del tema.
      function aplicarPrecios(d) {
        if (!d || !d.models || !d.models.length) return;
        if (typeof d.capStep === 'number') cfg.capStep = d.capStep;
        if (typeof d.noSimCut === 'number') cfg.noSimCut = d.noSimCut;
        if (typeof d.batteryMin === 'number') B = d.batteryMin;
        if (typeof d.tradeInBonus === 'number') { cfg.tradeBonus = d.tradeInBonus; renderTrade(); }
        if (Array.isArray(d.descuentos) && d.descuentos.length) { DESCUENTOS = d.descuentos; montarFallos(); }
        var porSlug = {};
        cfg.models.forEach(function (m) { porSlug[m.slug] = m; });
        cfg.models = d.models.map(function (p) {
          var m = porSlug[p.slug] || { id: 'p-' + p.slug, slug: p.slug, name: p.name, gen: (p.name.match(/^iPhone \d+/i) || [p.name])[0], img: null, colors: [] };
          m.low = p.low;
          m.high = p.high;
          m.caps = (p.caps || []).map(String);
          return m;
        });
      }
      function preseleccionar() {
        var conCodigo = new URLSearchParams(location.search).get('codigo');
        if (conCodigo) { codeForm.hidden = false; codeForm.elements.codigo.value = conCodigo; aplicarCodigo(conCodigo, true); return; }
        var pre = new URLSearchParams(location.search).get('modelo');
        if (!pre) return;
        var found = cfg.models.filter(function (x) { return x.slug === pre; })[0];
        if (found) pick(found);
      }
      var preciosUrl = cfg.endpoint.replace(/\/recompra\/?$/, '/recompra/precios');
      var listo = false;
      var terminar = function () { if (listo) return; listo = true; renderModels(search.value); preseleccionar(); };
      setTimeout(terminar, 3500);
      fetch(preciosUrl, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (listo) {
            aplicarPrecios(d);
            renderModels(search.value);
            if (state.model) {
              var actual = cfg.models.filter(function (x) { return x.slug === state.model.slug; })[0];
              if (actual) { state.model = actual; renderQuestions(); renderOffer(); } else reset();
            }
            return;
          }
          aplicarPrecios(d);
          terminar();
        })
        .catch(terminar);
    }

    function boot() { document.querySelectorAll('[data-cti]').forEach(function (r) { if (!r.dataset.ctiReady) { r.dataset.ctiReady = '1'; init(r); } }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();
})();
